import { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { PageContentRewardHistory, type RewardHistoryEntry } from '@restaurant/core'
import { WebRewardsPageService, toRewardHistoryEntries } from '@restaurant/viewmodels'

// Rendering cap. The API has no working limit param (GET /reward_transactions
// ignores the one the adapter sends and returns every row), and long histories
// are real — one production account has 688 transactions — so the page caps
// what it renders and lets the user ask for more.
const PAGE_SIZE = 50

export default function RewardHistoryPage() {
  const service = useMemo(() => new WebRewardsPageService(), [])
  const [entries, setEntries] = useState<RewardHistoryEntry[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | undefined>(undefined)
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  useEffect(() => {
    let cancelled = false

    const load = async () => {
      try {
        setLoading(true)
        setError(undefined)
        // userId/restaurantId are unused by the adapter — it reads
        // customerRewardId from the rewards store.
        const transactions = await service.getRewardHistory('', '')
        if (!cancelled) setEntries(toRewardHistoryEntries(transactions))
      } catch {
        if (!cancelled) setError('We could not load your points history. Please try again later.')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }

    void load()
    return () => {
      cancelled = true
    }
  }, [service])

  return (
    <div className="flex flex-col w-full">
      <PageContentRewardHistory
        entries={entries}
        loading={loading}
        error={error}
        maxVisible={visibleCount}
        onShowMore={() => setVisibleCount((c) => c + PAGE_SIZE)}
        testID="reward-history"
      />
      <div className="flex justify-center pb-8">
        <Link to="/rewards" className="text-primary-600 font-medium hover:underline">
          Back to Rewards
        </Link>
      </div>
    </div>
  )
}
